module.exports = __webpack_public_path__ + "static/media/FRESAS copia.6cb51979.webp";